// TAPINTO® Editor Frontend - Component Resolver
// Version: 1.0
// Date: 2025-10-01

import { Hero } from './components/Hero';
import { Text } from './components/Text';
import { Image } from './components/Image';
import { Button } from './components/Button';
import { TwoColumn } from './components/TwoColumn';

export const componentResolver = {
  Hero,
  Text,
  Image,
  Button,
  TwoColumn,
};
